import { patchState, StateSignals, WritableStateSource } from '@ngrx/signals';

import { TranslationState } from './translation.state';

export const translationFeatureMethodsFactory = (store: StateSignals<TranslationState> & WritableStateSource<TranslationState>) => {
  const changeLanguage = (language: string): void => {
    patchState(store, { currentLanguage: language });
    localStorage.setItem('language', language);
  };

  const translate = (key: string, params?: Record<string, string | number>) => {
    const translation = store._translations().get(key);
    return translation ? (params ? transpile(translation, params) : translation) : key;
  };

  const transpile = (translation: string, params: Record<string, string | number>) =>
    translation.replace(
      /\{\{(\w+)\}\}/g,
      (_, key) => `${params[key] ?? key}`,
    );

  return { changeLanguage, translate };
};
